module.exports = __webpack_public_path__ + "static/media/cb-build-profile.7f0f6895.mp4";